module.exports = __webpack_public_path__ + "img/history-dark-light.4dc80537.png";